@if (showButtonGroup() && hero(); as hero) {
  <div class="hero-button-group hero-button-group">
    @if (showPrimaryButton() || showSecondaryButton()) {
      <div
        class="hero-button-group__buttons"
        [class.hero-button-group__buttons--large]="large()"
      >
        @if (showPrimaryButton() && primaryButton(); as primaryButton) {
          <div>
            <crnt-button-alt
              class="hero-button-group__button"
              variant="primary"
              [inverted]="inverted()"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: { componentName: 'HeroButtonGroupComponent' },
                field: primaryButton?.value?.text ?? '',
                eventType: 'button-click',
                type: 'button',
              }"
            >
              <a *wlGenericLink="primaryButton"></a>
            </crnt-button-alt>
          </div>
        }
        @if (showSecondaryButton() && secondaryButton(); as secondaryButton) {
          <div>
            <crnt-button-alt
              class="hero-button-group__button"
              variant="secondary"
              [inverted]="true"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: { componentName: 'HeroButtonGroupComponent' },
                field: secondaryButton?.value?.text ?? '',
                eventType: 'button-click',
                type: 'button',
              }"
            >
              <a *wlGenericLink="secondaryButton"></a>
            </crnt-button-alt>
          </div>
        }
      </div>
    }

    @if (hero.appStoreButton && hero.googlePlayButton) {
      <wl-app-store-buttons
        app-store-buttons
        [appStoreButtonLink]="hero.appStoreButton"
        [googlePlayButtonLink]="hero.googlePlayButton"
        [displayColumn]="large() ? 'sm' : undefined"
        [inverted]="true"
      />
    }
  </div>
}
